import React from "react";
import Script from "next/script";

export type DatadogData = {
  clientToken?: string | null;
  applicationId?: string | null;
  serviceName?: string | null;
  version?: string | null;
  sessionSampleRate?: number;
  sessionReplaySampleRate?: number;
};

type DatadogRumScriptProps = {
  datadogData: DatadogData;
  environment: string;
};

export function DatadogRumScript({
  datadogData,
  environment,
}: DatadogRumScriptProps) {
  if (
    !datadogData?.serviceName ||
    !datadogData?.clientToken ||
    !datadogData?.applicationId
  ) {
    return null;
  }

  const { sessionSampleRate, sessionReplaySampleRate } = datadogData;

  return (
    <Script
      id="dd-browser-agent"
      dangerouslySetInnerHTML={{
        __html: `(function(h,o,u,n,d) {
          h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
          d=o.createElement(u);d.async=1;d.src=n
          n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
        })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js','DD_RUM')
        window.DD_RUM.onReady(function() {
          window.DD_RUM.init({
            clientToken: '${datadogData.clientToken}',
            applicationId: '${datadogData.applicationId}',
            site: 'datadoghq.com',
            service: '${datadogData.serviceName}',
            env: '${environment}',
            version: '${datadogData.version || "unknown"}',
            sessionSampleRate: ${sessionSampleRate},
            sessionReplaySampleRate: ${sessionReplaySampleRate},
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input',
          });
        })`,
      }}
    />
  );
}
